import React from 'react';
import JsxParser from 'react-jsx-parser';
import * as Sentry from '@sentry/browser';
import Img from '$components/library/Img';
import prepareJsx from './prepareJsx';

const Aaa = {
  Img,
};

const hasNotified = {};
const notifyOnce = ({ fragmentUuid, isStaff, data }) => {
  const { error } = data;
  if (!isStaff && !hasNotified[fragmentUuid]) {
    Sentry.captureException(`Rendering error in fragmentUuid: ${fragmentUuid}`);
    hasNotified[fragmentUuid] = true;
  }

  return (
    <div>
      <h2>Rendering error :-(</h2>
      <div>
        <p>An error somehow made it into this page of the content.</p>
        <p>Our team has automatically been notified and we will fix it asap.</p>
        <pre>{error}</pre>
      </div>
    </div>
  );
};

const MarkdownHtml = (props) => {
  const { enhanced, isStaff, fragmentUuid, jsx: originalJsx } = props;

  const jsx = prepareJsx({ originalJsx });

  if (!enhanced) {
    return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: jsx }} />;
  }

  return (
    <JsxParser
      className="markdown-body"
      components={{ Aaa }}
      renderError={(data) => notifyOnce({ isStaff, fragmentUuid, data })}
      jsx={jsx}
    />
  );
};

export default MarkdownHtml;
